const action = {
    general: '작업 실행 중 오류가 발생했습니다. 나중에 다시 시도하세요.',
    sign_in_identifier_changed: '작업은 이 검증에 사용된 로그인 식별자를 변경할 수 없습니다.',
};
export default Object.freeze(action);
